import { render, staticRenderFns } from "./tscheduledetail.vue?vue&type=template&id=370fecd2&"
import script from "./tscheduledetail.vue?vue&type=script&lang=js&"
export * from "./tscheduledetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports